<template>
  <div id="app">
    <my-nav></my-nav>
    <router-view />
    <my-footer></my-footer>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/footer'
export default {
  data() {
    return {}
  },
  components: {
    'my-nav': Nav,
    'my-footer': Footer,
  },
}
</script>

<style lang="scss">
</style>
